/**
 * Format pick_type for display: "total_bases" → "Total Bases", "two_hit" → "2+ Hits", etc.
 * @param {string} [pickType] - Raw pick type (e.g. total_bases, hr)
 * @returns {string} Human-readable label
 */
export function formatPickTypeLabel(pickType) {
  if (!pickType || typeof pickType !== 'string') return '';
  const normalized = pickType.trim().toLowerCase().replace(/_/g, ' ');
  const labels = {
    'total bases': 'Total Bases',
    'two hit': '2+ Hits',
    'hr': 'Home Run',
    'hit': 'Hit',
    'moneyline': 'Moneyline',
  };
  return labels[normalized] || normalized.replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Format prediction value for display: probabilities (Hit, 2+ Hits, HR) as percent (e.g. "63%"),
 * Total Bases as decimal (e.g. "2.58").
 * @param {string} [pickType] - Raw pick type (e.g. total_bases, hit, hr)
 * @param {number} [value] - Raw value (0–1 for probability, or TB amount)
 * @returns {string} Formatted string, or empty if value is null/undefined
 */
export function formatPickValue(pickType, value) {
  if (value == null || Number.isNaN(Number(value))) return '';
  const num = Number(value);
  const type = (pickType || '').toLowerCase().trim();
  if (type === 'hit' || type === 'two_hit' || type === 'hr') {
    return `${Math.round(num * 100)}%`;
  }
  return num.toFixed(2);
}
